import "./SbbPersona.scss";

import AppRoutes from "AppRoutes";
import classNames from "classnames";
import { useApi } from "providers";
import React, { useEffect, useReducer } from "react";

const cache = new Map<string, string | null>();

export interface SbbPersonaImageProps {
  profileImage?: string;
  title?: string;
  initials?: string;
  initialsColor?: string;
}

export const SbbPersonaImage: React.FC<SbbPersonaImageProps> = ({ profileImage, title, initials, initialsColor }) => {
  const { userApi } = useApi();
  const [, forceUpdate] = useReducer((x: number) => x + 1, 0);

  // Convert to absolute url, such that ApiContext does not rewrite it to be /api/users/images...
  const url = profileImage ? AppRoutes.getBackendUrl(profileImage) : null;
  const imageBase64 = url ? (cache.get(url) ?? "") : "";

  useEffect(() => {
    if (!url || cache.has(url)) return;

    userApi
      .getProfileImage(url)
      .then((data) => {
        cache.set(url, data);
        forceUpdate();
      })
      .catch(() => {
        cache.set(url, null);
        forceUpdate();
      });
  }, [userApi, url]);

  const imageLoaded = imageBase64 && !imageBase64.endsWith("base64,");
  const imageAreaClassName = classNames("ms-Persona-imageArea", imageLoaded ? "image-loaded" : "");

  return (
    <div className={imageAreaClassName}>
      <div
        className="ms-Persona-initials"
        title={title}
        style={{
          backgroundColor: title === "System" ? "#ddd" : initialsColor,
          color: title === "System" ? "#000" : undefined,
        }}
      >
        {initials}
      </div>
      {imageLoaded && (
        <div className="ms-Persona-image">
          <img aria-hidden="true" className="persona-image" src={imageBase64} alt={title} />
        </div>
      )}
    </div>
  );
};
